window.__tnt || (window.__tnt = {});
window.__tnt.pay || (window.__tnt.pay = {});
window.__tnt.pay.method || (window.__tnt.pay.method = {});

// init - runs at form init
// submitPayment - runs when the user clicks the pay button (if this is selected)

__tnt.pay.method.paypal = {
    name: "paypal",
    methodString: "PayPal",
    init: function(pf) {
        var paymentMethods = null,
            outputElement = null,
            paypalButton = null;

        if (pf) {
            paymentMethods = pf.dataset.paymentMethods;
            outputElement = pf.querySelector('.tn-pay-method-alt');
            paypalButton = outputElement.querySelector('.tn-pay-method-paypal');

            if (paymentMethods && paymentMethods.includes('paypal') && !pf['transaction_id']) {
                if (!paypalButton) {
                    paypalButton = document.createElement('a');
                    paypalButton.id = "paypal-payment-" + pf.dataset.spreedlyContext;
                    paypalButton.classList.add("btn", "btn-lg", "btn-block", "wallet-btn", "tn-pay-method", "tn-pay-method-paypal", "tn-pay-method-alt");
                    paypalButton.style = "";
                    paypalButton.dataset.paymentMethodEventLabel = __tnt.pay.method.paypal.methodString;
                    paypalButton.innerHTML = '<i class="fab tnt-paypal"></i> PayPal';
                    paypalButton.addEventListener('click',function(ev){
                        __tnt.pay.setPaymentMethod(pf, "paypal", this);
                    });
                    paypalButton.addEventListener('BLOXPaymentMethodSet', function() {

                        __tnt.subscription.offers.logPaymentInfoEntered({
                            step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                            paymentMethod: __tnt.pay.method.paypal.methodString
                        });

                    });
                }

                outputElement.appendChild(paypalButton);
            } else if (paypalButton) {
                paypalButton.remove();
            }
        }
    },
    submitPayment: function(pf) {
        try{
            var tntPay = null,
                elError = null,
                elErrorMessage = null,
                paypalForm = null;

            if (pf) {
                tntPay = pf.parentElement;
                
                if (tntPay) {
                    paypalForm = tntPay.querySelector('.tnt-payment-paypal-form');
                    elError = tntPay.querySelector('.tnt-payment-error');
                    
                    if(elError){ elErrorMessage = elError.querySelector('.error-message') }
                }
            }

            sessionStorage.setItem('__tnt.subscription.offers.purchaseType', pf.dataset.purchaseType);

            if(paypalForm){
                if (pf['service_id']) paypalForm['service_id'].value = pf['service_id'].value;
                if (pf['rate_id']) paypalForm['rate_id'].value = pf['rate_id'].value;
                if (pf['first_name']) paypalForm['first_name'].value = pf['first_name'].value;
                if (pf['last_name']) paypalForm['last_name'].value = pf['last_name'].value;
                if (pf['email']) paypalForm['email'].value = pf['email'].value;
                if (pf['password']) paypalForm['password'].value = pf['password'].value;
                if (pf['password_verify']) paypalForm['password_verify'].value = pf['password_verify'].value;
                if (pf['address']) paypalForm['address'].value = pf['address'].value;
                if (pf['municipality']) paypalForm['municipality'].value = pf['municipality'].value;
                if (pf['region']) paypalForm['region'].value = pf['region'].value;
                if (pf['postal_code']) paypalForm['postal_code'].value = pf['postal_code'].value;
                if (pf['country']) paypalForm['country'].value = pf['country'].value;
                if (pf['postal-address']) paypalForm['postal-address'].value = pf['postal-address'].value;
                if (pf['postal-city']) paypalForm['postal-city'].value = pf['postal-city'].value;
                if (pf['postal-state']) paypalForm['postal-state'].value = pf['postal-state'].value;
                if (pf['postal-postcode']) paypalForm['postal-postcode'].value = pf['postal-postcode'].value;
                if (pf['postal-country']) paypalForm['postal-country'].value = pf['postal-country'].value;
                if (pf['phone']) paypalForm['phone'].value = pf['phone'].value;

                let paypalFormData = new FormData(paypalForm);

                try {
                    //let errorLogged = false;
                    fetch('/tncms/subscription/buy_paypal/', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json'
                        },
                        body: paypalFormData
                    }).then(function(oPayload) {
                        return oPayload.json().then(function(oResp) {
                            if (oPayload.ok && oResp.redirect_url) {
                                try {
                                    sessionStorage.setItem('__tnt.error.messsage', "An error occurred: Paypal payment method error.");
                                } catch(error) {
                                    console.warn("Unable to set session data", error);
                                }
                                window.location.href = oResp.redirect_url;

                            } else {
                                tntPaymentError.detail = {};
                                tntPaymentError.detail.message = "An error occurred";

                                var message = "An error occurred";
                                if (oResp.message) {
                                    tntPaymentError.detail.message = oResp.message;
                                    message += ": " + oResp.message;
                                }

                                var httpStatus = null;
                                if (oResp.code) httpStatus = oResp.code;

                                var httpStatusFatal = false;
                                if (oResp.code > 499) httpStatusFatal = true;

                                window.dispatchEvent(new CustomEvent('BLOXException', {
                                    'bubbles': true,
                                    'detail': {
                                        'description': message,
                                        'http_status': httpStatus,
                                        'fatal': httpStatusFatal,
                                        'error_code': "PayloadFailure",
                                        'category': "subscription",
                                        'payment_method': __tnt.pay.method.paypal.name,
                                        'payment_gateway': null,
                                        'ecommerce_channel': 'subscription'
                                    }
                                }));

                                pf.dispatchEvent(tntPaymentError);
                            }
                        });
                    }).catch(function(error) {
                        console.error(error);

                        tntPaymentError.detail = {};
                        tntPaymentError.detail.message = "An error occurred";

                        var message = "An error occurred";
                        if (error && error.message) message += ": " + error.message;

                        window.dispatchEvent(new CustomEvent('BLOXException', {
                            'bubbles': true,
                            'detail': {
                                'description': message,
                                'http_status': null,
                                'fatal': false,
                                'error_code': "FetchError",
                                'category': "subscription",
                                'payment_method': __tnt.pay.method.paypal.name,
                                'payment_gateway': null,
                                'ecommerce_channel': 'subscription'
                            }
                        }));

                        pf.dispatchEvent(tntPaymentError);
                    });
                } catch(error) {
                    console.error(error);

                    tntPaymentError.detail = {};
                    tntPaymentError.detail.message = "An error occurred";

                    var message = "An error occurred";
                    if (error && error.message) message += ": " + error.message;

                    var httpStatus = null;
                    var httpStatusFatal = false;

                    window.dispatchEvent(new CustomEvent('BLOXException', { 
                        'bubbles': true,
                        'detail': {
                            'description': message,
                            'http_status': httpStatus,
                            'fatal': httpStatusFatal,
                            'error_code': "PurchaseError",
                            'category': "subscription",
                            'payment_method': __tnt.pay.method.paypal.name,
                            'payment_gateway': null,
                            'ecommerce_channel': 'subscription'
                        }
                    }));

                    pf.dispatchEvent(tntPaymentError);
                }
            }
        } catch(error){
            console.error(error);

            tntPaymentError.detail = {};
            tntPaymentError.detail.message = "An error occurred";

            var message = "An error occurred";
            if (error && error.message) message += ": " + error.message;

            window.dispatchEvent(new CustomEvent('BLOXException', { 
                'bubbles': true,
                'detail': {
                    'description': message,
                    'http_status': null,
                    'fatal': false,
                    'error_code': "GeneralPaymentError",
                    'category': "subscription",
                    'payment_method': __tnt.pay.method.paypal.name,
                    'payment_gateway': null,
                    'ecommerce_channel': 'subscription'
                }
            }));

            pf.dispatchEvent(tntPaymentError);
        }

    }
};

